module.exports = __webpack_public_path__ + "img/Z61Q_11.60070949.jpg";